export default __webpack_public_path__ + "static/media/2360.4d19fa81.png";